import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faFolderOpen, faHashtag, faPercentage, faSave, faTimes, faUpload } from '@fortawesome/free-solid-svg-icons';

class Cargar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        files: '',
        municipioLibreta: [],
        departamentosVisita: [],
        municipiosVisita: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    cambioValorFiles = (e) => {
        this.setState({ files: e.target.files });
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { files } = this.state;
        let form = document.getElementById('form');
        let formData = new FormData(form);
        for (let i = 0; i < files.length; i++) {
            formData.append(files[i].name, files[i])
        }
        console.log(formData);
        Swal.showLoading();
        authAxios.post("bitacora_visitas/cargar_bitacora", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Bitacora Visitas!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterBitacoraVisitas");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Bitacora Visitas!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    cargarMunicipios = () => {
        var id_departamento = document.getElementById('ID_DEPARTAMENTO').value;
        this.setState({ municipiosVisita: [] });
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_departamento)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, municipiosVisita: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("bitacora_visitas/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, municipioLibreta: datosRespuesta.data, load: '' });
                var id_departamento = datosRespuesta.data.ID_DEPARTAMENTO;
                document.getElementById("ID_DEPARTAMENTO").value = id_departamento;
            })
            .catch(console.log);
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, departamentosVisita: datosRespuesta.data.data, load: '' });
                this.cargarMunicipios();
            })
            .catch(console.log);
    }
    render() {
        const { id_departamento, id_municipio,
                departamentosVisita, municipiosVisita, municipioLibreta
            } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>CARGAR DOCUMENTOS BITACORA</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_DEPARTAMENTO">Departamento</label>
                                                    <input type="hidden" name="id_municipio_libreta" id='id_municipio_libreta' value={this.props.match.params.id} />
                                                    <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                    <input type="hidden" name="departamento" id="departamento" value={municipioLibreta.NOMBRE_DEPARTAMENTO} />
                                                    <input type="hidden" name="municipio" id="municipio" value={municipioLibreta.NOMBRE_MUNICIPIO} />
                                                    <select name="ID_DEPARTAMENTO"
                                                        id="ID_DEPARTAMENTO"
                                                        value={municipioLibreta.ID_DEPARTAMENTO}
                                                        options={municipioLibreta.ID_DEPARTAMENTO}
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor} disabled>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentosVisita.map((itemDepartamentosVisita) => (
                                                                <option key={itemDepartamentosVisita.ID_DEPARTAMENTO} value={itemDepartamentosVisita.ID_DEPARTAMENTO}>{itemDepartamentosVisita.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="id_municipio">Municipio</label>
                                                    <select name="id_municipio"
                                                        id="id_municipio"
                                                        value={municipioLibreta.ID_MUNICIPIO}
                                                        options={municipioLibreta.ID_MUNICIPIO}
                                                        className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor} disabled>
                                                        <option value="">Seleccione el Municipio</option>
                                                        {
                                                            municipiosVisita.map((itemMunicipiosVisita) => (
                                                                <option key={itemMunicipiosVisita.ID_MUNICIPIO} value={itemMunicipiosVisita.ID_MUNICIPIO}>{itemMunicipiosVisita.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-6'>
                                                    <label htmlFor="files">Archivos Liquidaciones</label>
                                                    <div className='input-group input-group-sm mb-3'>
                                                        <label className="input-group-text label_files" htmlFor="files"><FontAwesomeIcon icon={faFolderOpen} />&nbsp;&nbsp;Seleccionar Archivo(s) </label>
                                                        <input className="form-control form-control-sm" type="file" id="files" multiple onChange={this.cambioValorFiles} />
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label style={{ color: '#FFFFFF' }} htmlFor="upload-files">Subir Archivo(s)</label>
                                                    <button type="submit" className="btn btn-success btn-sm" id='upload-files' name='upload-files'><FontAwesomeIcon icon={faUpload} />&nbsp;&nbsp;Subir Archivo(s)</button>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-12'>
                                                    <div className="progress">
                                                        <div style={{ width: "0%" }} className="progress-bar progress-bar-striped progress-bar-animated" id='progress_files' role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-xl-12 text-center'>
                                                    <div className="btn-group" role="group" aria-label="">
                                                        <Link className="btn btn-danger btn-sm" to={"/MasterBitacoraVisitas"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Cargar;